import React, {useState } from 'react'
import {CLIENT, CLIENT_LIST_FOR_USER, LIST, getApiPath} from '../../api/ApiConst';
import TableFilter from '../constants/TableFilter';
import * as NavConst from '../constants/NavigationConstants';
import { useNavigate } from "react-router-dom";




const ClientMaster = () => {

    const navigate = useNavigate();
    const [clientDrawCount, setClientDrawCount] = useState(0)


    const [clientDataObj, setClientDataObj] = useState({
        id: "",
        clientName: "",
        thirdPartyId: "",
        ipAddress: "",
        clientId: "",
        clientSecret: "",
        postLogoutRedirectUris: [],
        redirectUris: [],
        primaryDbDetail: {
            host: "",
            port: null,
            dbName: "",
            authDbName: "",
            authUsername: "",
            authPassword: ""
        },
        secondaryDb: false,
        secondaryDbDetail: {
            host: "",
            port: null,
            dbName: "",
            authDbName: "",
            authUsername: "",
            authPassword: ""
        },
        backUpDb: false,
        backUpDbDetail: {
            host: "",
            port: null,
            dbName: "",
            authDbName: "",
            authUsername: "",
            authPassword: ""
        },
        authorizationCodeTimeToLive: 0,
        accessTokenTimeToLive: 0,
        accessTokenFormat: {label: "Self-Contained", value: "self-contained"},
        deviceCodeTimeToLive: 0,
        reuseRefreshTokens: true,
        refreshTokenTimeToLive: 0,
        idTokenSignatureAlgorithm: {
            label: "RS256",
            value: "RS256"
        },
        requireProofKey: true,
        requireAuthorizationConsent: true,
        cscopy: "",
        scopes: [],
        clientAuthenticationMethods: [],
        authorizationGrantTypes: []
    })


    const handleCreateClient = () => {
        let rObj = {
            clientName: "",
            thirdPartyId: "",
            ipAddress: "",
            clientId: "",
            clientSecret: "",
            postLogoutRedirectUris: [],
            redirectUris: [],
            primaryDbDetail: {
                host: "",
                port: null,
                dbName: "",
                authDbName: "",
                authUsername: "",
                authPassword: ""
            },
            secondaryDb: false,
            secondaryDbDetail: {
                host: "",
                port: null,
                dbName: "",
                authDbName: "",
                authUsername: "",
                authPassword: ""
            },
            backUpDb: false,
            backUpDbDetail: {
                host: "",
                port: null,
                dbName: "",
                authDbName: "",
                authUsername: "",
                authPassword: ""
            },
            authorizationCodeTimeToLive: 0,
            accessTokenTimeToLive: 0,
            accessTokenFormat: {label: "Self-Contained", value: "self-contained"},
            deviceCodeTimeToLive: 0,
            reuseRefreshTokens: true,
            refreshTokenTimeToLive: 0,
            idTokenSignatureAlgorithm: {
                label: "RS256",
                value: "RS256"
            },
            requireProofKey: true,
            requireAuthorizationConsent: true,
            cscopy: "",
            scopes: [],
             clientAuthenticationMethods: [],
             authorizationGrantTypes: []
        };
        setClientDataObj(rObj)
        
        let fetchDetails = {
			clientDataObj: rObj,
			type: "fetch",
		};
        let detail_Url = NavConst.CLIENT_ADD_UPDATE.replaceAll(":clientId", "add-client");
		navigate(detail_Url, { state: fetchDetails }); 
    }

    const handleUpdateClientData = (rowData) => {
       let fetchDetails = {
            type: "fetch",
        };
        
        let detail_Url = NavConst.CLIENT_ADD_UPDATE.replaceAll(":clientId", rowData.id);
        navigate(detail_Url, { state: fetchDetails });
    }
    const refreshTableData = () => {
        setClientDrawCount((prev) => (prev + 1));
    };

   
    return (
        <>
            <div className="row justify-content-end my-3">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body p-0">
                            <div className='d-flex justify-content-end mb-3 me-0 table-info'>
                                <button className="btn btn-primary"
                                    onClick={handleCreateClient}> Create New</button>
                            </div>
                            <TableFilter
                                tableName="client"
                                tableUrl={getApiPath(CLIENT, CLIENT_LIST_FOR_USER)}
                                paginationStatus={true}
                                drawCount={clientDrawCount}
                                showRecordUpdateModel={handleUpdateClientData}
                                refreshTableData={refreshTableData}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ClientMaster